import { useId } from "react";

// iuni mark: five interlocking hearts forming a flower, sunset gradient
export const IuniFlower = ({ size = 28, className = "" }) => {
  const gradientId = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id={gradientId} x1="0" y1="0" x2="48" y2="48" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor="#E07A5F" />
          <stop offset="100%" stopColor="#E2856E" />
        </linearGradient>
      </defs>
      {[0, 72, 144, 216, 288].map((angle) => (
        <path
          key={angle}
          transform={`rotate(${angle} 24 24)`}
          d="M24 12.4c-1.1-2.2-3.9-3-5.8-1.6-1.7 1.2-2.2 3.5-1.1 5.3 1.3 2.1 4.4 4.4 6.9 5.6 2.5-1.2 5.6-3.5 6.9-5.6 1.1-1.8.6-4.1-1.1-5.3-1.9-1.4-4.7-.6-5.8 1.6z"
          fill={`url(#${gradientId})`}
        />
      ))}
    </svg>
  );
};
